export default {
  companyUpdates: {
    code: 'c',
    name: 'Company Updates',
    slug: 'company-updates',
  },
  other: {
    code: 'o',
    name: 'Other',
    slug: 'other',
  },
  resortGuides: {
    code: 'g',
    name: 'Resort Guides',
    slug: 'resort-guides',
  },
  snowAndWeatherScience: {
    code: 'l',
    name: 'Snow & Weather Science',
    slug: 'snow-and-weather-science',
  },
  snowpackUpdates: {
    code: 's',
    name: 'Snowpack Updates',
    slug: 'snowpack-updates',
  },
  tripReports: {
    code: 't',
    name: 'Trip Reports',
    slug: 'trip-reports',
  },
  videosAndPodcasts: {
    code: 'm',
    name: 'Video & Podcasts',
    slug: 'videos-and-podcasts',
  },
};
